export default __webpack_public_path__ + "static/media/about_img.6549a193.jpg";